import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleDoubleDown, faAngleDoubleUp, faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { watchImmediate } from "@vueuse/core";
import { BButton, BFormInput, BInputGroup, BInputGroupAppend } from "bootstrap-vue";
import { ref, watch } from "vue";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DelayedInput',
    props: {
        value: { default: "" },
        delay: { default: 1000 },
        loading: { type: Boolean, default: false },
        placeholder: { default: "Enter your search term here." },
        showAdvanced: { type: Boolean, default: false },
        enableAdvanced: { type: Boolean, default: false }
    },
    emits: ["input", "change", "onToggle"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faAngleDoubleDown, faAngleDoubleUp, faSpinner, faTimes);
        const queryInput = ref();
        const queryTimer = ref(null);
        const titleClear = ref("Clear Search (esc)");
        const titleAdvanced = ref("Toggle Advanced Search");
        const toolInput = ref(null);
        function clearTimer() {
            if (queryTimer.value) {
                clearTimeout(queryTimer.value);
            }
        }
        function delayQuery(query) {
            clearTimer();
            if (query) {
                queryTimer.value = setTimeout(() => {
                    setQuery(query);
                }, props.delay);
            }
            else {
                setQuery(query);
            }
        }
        function setQuery(queryNew) {
            emit("input", queryNew);
            emit("change", queryNew);
        }
        watch(() => queryInput.value, () => delayQuery(queryInput.value ?? ""));
        function clearBox() {
            queryInput.value = "";
            toolInput.value?.focus();
        }
        function onToggle() {
            emit("onToggle", !props.showAdvanced);
        }
        watchImmediate(() => props.value, (newQuery) => {
            queryInput.value = newQuery;
        });
        return { __sfc: true, props, emit, queryInput, queryTimer, titleClear, titleAdvanced, toolInput, clearTimer, delayQuery, setQuery, clearBox, onToggle, faAngleDoubleDown, faAngleDoubleUp, faSpinner, faTimes, FontAwesomeIcon, BButton, BFormInput, BInputGroup, BInputGroupAppend, localize };
    }
});
